import React, { useMemo } from "react";
import TabSlider from "../components/tabsComponent";
import SearchBar from "../components/SearchBar/SearchBar";
import PriceTable from "../components/newTable/priceTable";
import {
  pricing,
  setConfig,
  setFilteredRedux,
  setPageCount,
  setPageSizeRedux,
  setPageRedux,
  setSorting,
  setUserTable,
  setActiveTab,
  setIsPreFiltered,
  setPreDefinedFilter,
  setSearchParamRedux,
} from "../redux/slices/pricingSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  useGetConfigQuery,
  useGetFilteredDataMutation,
  useGetSupplierTableWithMultiSortingQuery,
  useGetSupplierTableWithSortingQuery,
  useGetSupplierTableWithStateQuery,
} from "../redux/slices/apiSlice";
import { Button, CircularProgress, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import DownloadMenu from "../components/downloadMenu";
import { useLocation, useNavigate} from "react-router-dom";
import {
  ML_CONFIDENCE_KEY,
  MLfilterKeys,
  cn,
  convertToJsonObject,
  filterKeys,
  mapping,
  sortMapping,
  filterReverseMappingSavedSearch
} from "../utils/utils";
import { useEffect } from "react";
import { auth } from "../redux/slices/authSlice";
import amplitude from "../utils/ampli";
import TopFilterDrawer from "../components/ui/topFilterDrawer";
import { Lock, Check, ListTodo, ListChecks, FilterIcon } from 'lucide-react';
import BulkLock from "../components/bulkLock";
import { setSeverity, setAlertText, setToast } from "../redux/slices/commonComponentSlice";
import BulkRepricing from "../components/BulkReprice/BulkRepricing";
import BulkAutoReprice from "../components/BulkReprice/BulkAutoReprice";
import CategoryArrayGenerated from "../components/ui/categoryChips";

function useQuery() {
  const { search } = useLocation();

  return new URLSearchParams(search);
}

const PriceCoPilot = ({ accountDetails }) => {
  let query = useQuery(); // convert the params to search items.
  const [page, setPage] = useState(parseInt(query.get("page")) ?? pageRedux);
  const pageRedux = useSelector(pricing).page;
  const absSort = query.get("abs_sort") === "true";
  if (query.get("page") == null) {
    query.set("page", pageRedux);
  }

  const token = useSelector(auth).token;
  const pSize = useSelector(pricing).pageSize;
  const isPreFilteredRedux = useSelector(pricing).isPreFiltered;
  
  const preDefinedFilterRedux = useSelector(pricing).preDefinedFilter;
  const preDefinedSortRedux = useSelector(pricing).preDefinedSort;
  

  const qPage = query.get("page");

  useEffect(() => {
    if (qPage !== pageRedux) {
      dispatch(setPageRedux(qPage));
    }
    setPage(parseInt(qPage));
  }, [qPage]);

  // get the page number
  const navigate = useNavigate();
  const location = useLocation();

  const dispatch = useDispatch();
  const userTable = useSelector(pricing).userTable;
  const [pageSize, setPageSize] = React.useState(pSize);

  const sort_by = useSelector(pricing)?.config?.sort_by;

  const sortByMapping = {
    sell_offer_cents: "sell_offer_cents",
    rap_discount: "rap_percent",
    price_per_carat: "price_per_carat",
  };

  useEffect(() => {
    if (sort_by && sortState.length == 0) {
      const x = {
        sorting: true,
        asc_desc: "asc",
        sort_by: sortByMapping[sort_by],
      };
      setSortState([x]);
    }
  }, [sort_by]);

  // const [sorting, setSorting] = React.useState({
  //   sorting: false,
  //   asc_desc: "asc",
  //   sort_by: "sell_offer_cents",
  // });
  // const initialCerts = useMemo(() => {
  //   const q = new URLSearchParams(location.search);
  //   return q.get("cert_numbers") ?? "";          // "" when not present
  // }, [location.search]);

  // useEffect(() => {
  //   if (initialCerts) dispatch(setSearchParamRedux(initialCerts));
  // }, [initialCerts]);

  const searchRedux = useSelector(pricing).searchParam;
  const filteredRedux = useSelector(pricing).filtered;
  const [prevSearch, setPrevSearch] = useState("");
  const customFiltersRaw = useSelector(pricing)?.config?.custom_filters;
  const [searchParam, setSearchParam] = useState(searchRedux);
  const activeTabRedux = useSelector(pricing).activeTab;
  
  const [activeTab, setActiveTab] = useState(activeTabRedux);
  const [filtered, setFiltered] = useState(filteredRedux);
  const [isPreFiltered, setIsPreFilteredLocal] = useState(isPreFilteredRedux);
  const [preDefinedFilter] = useState(preDefinedFilterRedux);
  const [preDefinedSort] = useState(preDefinedSortRedux);

  const [anchorBulkEl, setAnchorBulkEl] = useState(null);
  const open = Boolean(anchorBulkEl);

  const handleBulkClick = (event) => {
    setAnchorBulkEl(event.currentTarget);
  };

  // Build a friendly label map for known raw keys and custom filters
  const customFiltersRawByKey = useMemo(() => {
    const raw = customFiltersRaw || [];
    return Object.fromEntries(raw.map((f) => [f.key, f]));
  }, [customFiltersRaw]);

  const friendlyLabelMap = useMemo(
    () => ({
      // Discrete/default labels may already be friendly (Color, Shape, etc.)
      // Map raw keys to friendly labels for range/market/custom filters
      "stock_performance_data.needs_surplus": "Needs/Surplus",
      "ld_analysis_hash.rap_rank": "Rank",
      "ld_analysis_hash.rap_matching_count": "Count",
      change_in_rap_rank: "Rank change",
      change_in_rap_count: "Count change",
      market_items_added_array_count: "Added",
      market_items_sold_array_count: "Sold",
      "attr_types.for_sale_from": "Aging",
      total_saved_prmi: "Broad Count",
      inventory_items_count: "My Stock",
      sold_items_count: "My Sales",
      ytd_sales_count: "My YTD Sales",
      last_n_days_added_array_count: "Added (30 D)",
      last_n_days_sold_array_count: "Sold (30 D)",
      last_n_days_rank_change: "Rank Change (30 D)",
      last_n_days_count_change: "Count Change (30 D)",
      "stock_performance_data.turn": "Turn",
      "stock_performance_data.overhang": "Overhang",
      "stock_performance_data.needs": "Needs",
      "stock_performance_data.grouped_need": "Grouped Needs",
      // Custom enums/ranges (fall back to config labels when present)
      "attr_types.all#custom_data.buyer_name": "Buyer",
      "attr_types.all#custom_data.internal_grading": "Spec",
      "attr_types.all#custom_data.memo_stock": "Memo Stock",
      "attr_types.all#custom_data.pcp_table_inc": "Table Inc",
      "attr_types.all#custom_data.pcp_side_inc": "Side Inc",
      "attr_types.all#custom_data.open_in_girdle": "Open in Girdle",
      "attr_types.all#custom_data.natural_in_crown": "Natural in Crown",
      "attr_types.all#custom_data.natural_in_pav": "Natural in Pav",
      "attr_types.all#custom_data.natural_in_girdle": "Natural in Girdle",
      "attr_types.all#custom_data.memo_count": "Memo Count",
    }),
    []
  );

  // Create criteria map from `filtered` (array of {id, value})
  const criteriaMap = useMemo(() => {
    try {
      if (!Array.isArray(filtered) || filtered.length === 0) return {};
      const map = {};

      // Helper to resolve label
      const getLabel = (id) => {
        // Prefer config-provided labels for custom filters
        if (customFiltersRawByKey[id]?.label) return customFiltersRawByKey[id].label;
        return friendlyLabelMap[id] || id;
      };

      // Build quick lookup of custom enum options for inclusion calculation
      const customEnumOptions = Object.fromEntries(
        Object.entries(customFiltersRawByKey).map(([k, v]) => [k, v?.options || []])
      );

      filtered.forEach((f) => {
        if (!f || f.value == null) return;
        const id = f.id;

        // Measurements: value is an object of sub-ranges
        if (id === "Measurements" && typeof f.value === "object" && !Array.isArray(f.value)) {
          Object.entries(f.value).forEach(([sub, range]) => {
            if (
              range &&
              typeof range === "object" &&
              range.min !== undefined &&
              range.max !== undefined
            ) {
              map[sub] = `${range.min} - ${range.max}`;
            }
          });
          return;
        }

        // Range style filter: {min, max}
        if (
          typeof f.value === "object" &&
          !Array.isArray(f.value) &&
          f.value.min !== undefined &&
          f.value.max !== undefined
        ) {
          const label = getLabel(id);
          map[label] = `${f.value.min} - ${f.value.max}`;
          return;
        }

        // Discrete arrays
        if (Array.isArray(f.value)) {
          // Custom enums store EXCLUDED values; derive included using config options when available
          if (customEnumOptions[id]) {
            const all = customEnumOptions[id];
            const excluded = new Set(f.value);
            const included = all.filter((opt) => !excluded.has(opt));
            if (included.length > 0 && included.length !== all.length) {
              map[getLabel(id)] = included.join(", ");
            }
          } else {
            if (f.value.length > 0) {
              map[getLabel(id)] = f.value.join(", ");
            }
          }
        }
      });

      return map;
    } catch (e) {
      return {};
    }
  }, [filtered, customFiltersRawByKey, friendlyLabelMap]);

  const handleBulkClose = () => {
    setAnchorBulkEl(null);
  };


  // const inputObject = {
  //   "0": {
  //     "attr_types.diamond#color": "asc"
  //   },
  //   "1": {
  //     "item_carat_range": "desc"
  //   },
  //   "2": {
  //     "attr_types.diamond#color": "asc"
  //   },
  //   "3": {
  //     "attr_types.diamond#clarity": "desc"
  //   }
  // };

function convertSortObjectToArray(value) {
  return Object.keys(value).map(key => {
    const innerObject = value[key];
    const sortBy = Object.keys(innerObject)[0];
    const ascDesc = innerObject[sortBy];
    
    return {
      sorting: true,
      asc_desc: ascDesc,
      sort_by: sortBy
    };
  });
}
 
  
  useEffect(() => {
    if (location.pathname === "/") {
      dispatch(setIsPreFiltered(false));
      navigate("/price_co-pilot?page=0");
    }
  }, [navigate, location]);

  

  const setPageSizeFn = (ev) => {
    setPage(0);
    if(absSort){
      query.set("page", 0);
      navigate(`/price_co-pilot?${query}`);
    }else{
    navigate(`/price_co-pilot?page=0`);
    }
    setPageSize(parseInt(ev.target.value, 10));
    dispatch(setPageSizeRedux(parseInt(ev.target.value, 10)));
  };

  let sorting = useSelector(pricing).sorting;

  // BUG - While first time loading the page - sorting is undefined, so backend request failed to give response
  // Applying default multisort in the color(D, E, F) and clarity (VVS1, VVS2, VS1, VS2 ....)
  if (sorting.length === 0) {
    sorting = [
      {
        sorting: true,
        asc_desc: "asc",
        sort_by: "attr_types.diamond#shape"
      },
      {
        sorting: true,
        asc_desc: "desc",
        sort_by: "item_carat_range"
      },
      {
        sorting: true,
        asc_desc: "asc",
        sort_by: "attr_types.diamond#color"
      },
      {
        sorting: true,
        asc_desc: "asc",
        sort_by: "attr_types.diamond#clarity"
      },
      
      
    ];
  }
  
  // if(preDefinedSort){
  //   console.log("preDefinedSort", savedSearchSort)
  //   sorting = savedSearchSort;
  // }

  const defaultMultisort = [
    {
      sorting: true,
      asc_desc: "asc",
      sort_by: "attr_types.diamond#color"
    },
    {
      sorting: true,
      asc_desc: "asc",
      sort_by: "attr_types.diamond#clarity"
    }
  ];

  const [sortState, setSortState] = useState(sorting);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [allSelected, setAllSelected] = useState(false);
  const toggleDrawer = (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setOpenDrawer(!openDrawer);
  };

  const [tabState, setTabState] = useState({
    data: null,
    isLoading: null,
    isSuccess: null,
    isError: null,
    error: null,
    isFetching: null,
    currentData: null,
    total_matching_count: null,
  });

  const {
    data,
    isLoading,
    isSuccess,
    isError,
    error,
    isFetching,
    currentData,
  } = useGetSupplierTableWithMultiSortingQuery(
    {
      id: accountDetails.account_id,
      from: page ? pageSize * page : 0,
      size: pageSize,
      asc_desc: sortState[0]?.asc_desc ?? "asc",
      sort_by: sortState[0]?.sort_by ?? null,
      search: searchParam,
      sort: sortState,
      // Change the below index, if the ordering changes in tabsList
      // tabsList={[
      //  {key: "All", value: "all", width: "100px", index: 0},
      //  {key: "Pending", value: "pending", width: "100px", index: 1},
      //  {key: "Locked", value: "locked", width: "100px", index: 2},
      //  {key: "Repriced", value: "repriced", width: "100px", index: 3},
      // ]}
      state: activeTab == 3 ? "repriced" : "",
      is_filter_locked: activeTab == 1 ? false : activeTab == 2 ? true : "",
      isSearched: searchParam !== prevSearch,
    },
    {
      skip: filtered.length > 0 || isPreFiltered,
    }
  );
  useEffect(() => {
    // Check specifically for abs_sort parameter
    if (absSort) {
      const sortBy = query.get("sort_by");
      const ascDesc = query.get("asc_desc") || "asc";
      const isFilterLocked = query.get("is_filter_locked");
      const certNumbersParam = query.get("cert_numbers");
      // http://localhost:3000/price_co-pilot?sort_by=rank_change_price_impact&asc_desc=desc&abs_sort=true&cert_numbers=2175263153,6511447098,1232427194,2497271874,5222174504,6492129799,7516336976,6492069447,3515310854,6502342906,6511001181,2231476903,1518141201,6492995463,5483839307,5221690495,2125616140,1518445713,1517792823,7513958713,1488641164,1518731055,5141303137,1232543683,6515618122
      // Handle sorting
      if (sortBy) {
        const sortObj = {
          sorting: true,
          asc_desc: ascDesc,
          sort_by: sortMapping[sortBy] || sortBy
        };
        setSortState([sortObj]);
        dispatch(setSorting([sortObj]));
      }
      if (certNumbersParam && certNumbersParam !== searchParam) {
      setSearchParam(certNumbersParam);        
      dispatch(setSearchParamRedux(certNumbersParam));
      dispatch(setPageRedux(0));
  }
      
      // Handle filter locked state if present
      if (isFilterLocked === "true") {
        setActiveTab(2); // "Locked" tab
        // dispatch(setActiveTab(2));
        dispatch(setIsPreFiltered(true));
      } else if (isFilterLocked === "false") {
        setActiveTab(1); // "Pending" tab
        // dispatch(setActiveTab(1));
        dispatch(setIsPreFiltered(true));
      }
      
      // Prevent the URL from being reset by other useEffects
      // by setting a flag that other useEffects can check
      // sessionStorage.setItem('preserveUrlParams', 'true');
    }
  }, [absSort]);
  // useEffect(() => {
  //   query.set("page", 0);
  //   navigate("/price_co-pilot"); // reset the pagination by reseting the url.
  //   // if (activeTab > 0) setSkipRepriced(false);
  // }, [activeTab]);

  useEffect(() => {
    if (isFetching && !currentData) {
      // console.log("is fetching is called");
      dispatch(setUserTable(null));
      dispatch(setPageCount(0));
    }
  }, [currentData, isFetching]);

  // Show backend error from query (e.g., when search exceeds backend limit)
  useEffect(() => {
    if (isError) {
      const backendMessage = (error && (error.data?.message || error.error || error.status)) || "Something went wrong";
      dispatch(setSeverity("error"));
      dispatch(setAlertText(String(backendMessage)));
      dispatch(setToast(true));
    }
  }, [isError, error, dispatch]);

  useEffect(() => {
    if (data && filtered.length == 0) {
      dispatch(setUserTable(data?.data.map((item) => mapping(item))));
      dispatch(setPageCount(data.total_matching_count));
      setTabState({
        data: data?.data,
        isLoading,
        isSuccess,
        isError,
        error,
        isFetching,
        currentData,
        total_matching_count: data?.total_matching_count,
      });
    }
  }, [data]);

  // config.

  // const {
  //   data: configData,
  //   isLoading: configLoading,
  //   isSuccess: configSuccess,
  //   isError: configIsError,
  //   error: configError,
  // } = useGetConfigQuery({
  //   accId: accountDetails.account_id,
  // });

  // useEffect(() => {
  //   if (configData) {
  //     dispatch(setConfig(configData?.data));
  //   }
  // }, [configData]);
  function transformFilters(transformedFilters) {
    const newFormat = [];
    
    // Process custom data filters
      if (transformedFilters.custom_data_filters?.attr_types?.["all#custom_data"]) {
      const customData = transformedFilters.custom_data_filters.attr_types["all#custom_data"];
      
      Object.entries(customData).forEach(([key, value]) => {
        const configEntry = customFiltersRaw.find(c => c.key === `attr_types.all#custom_data.${key}`);
        
        if (!configEntry) return;

        if (configEntry.type === "range") {
           newFormat.push({
          id: configEntry.key,
          value: {
            min: Number(value.from),
            max: Number(value.to)
          }
        });
      } else if (configEntry.type === "enum") {
          const allOptions = configEntry.options ?? [];
          const selected = value;
          const excluded = allOptions.filter(opt => !selected.includes(opt));
          newFormat.push({
            id: configEntry.key,
            value: excluded
          });
        }
      });
    }
    // Item filter from and to
    if (transformedFilters.item_filter.discrete) {
      for (const [key, values] of Object.entries(transformedFilters.item_filter.discrete)) {
        const filterKey = filterReverseMappingSavedSearch[key]; // e.g., "diamond#symmetry" -> "Symmetry"
        const values_new = values.map(value => value.toString().slice(4).toLowerCase()); // e.g ["0000ex"] to ["ex"]

        let filterKeynew = filterKey.toString().toLowerCase()
        if (filterKey == "Symmetry"){
          filterKeynew = "sym"
        } else if (filterKey == "Fluor"){
          filterKeynew = "flr" 
        } else if (filterKey == "Lab"){
          filterKeynew = "lab"
        } else if (filterKey == "Location"){
          filterKeynew = "locations"
        }

        if (filterKeys[filterKeynew]) {
          const remainingValues = filterKeys[filterKeynew].filter(value => !values_new.includes(value.toString().toLowerCase())); // ["VG", "Good", "Fair", "Poor"]
          newFormat.push({ id: filterKey, value: remainingValues }); //{id: Symmetry, value: ["VG", "Good", "Fair", "Poor"]}
        }
      }
    }

    // item filter text
    if (transformedFilters.item_filter.text) {
      // {"diamond#key_to_symbol": "bruise,cavity,chip,cloud,crystal,etch_channel,extra_facet,feather,grain_center,indented_natural,internal_graining,knot,laser_drilling,manufacturing_remnant,minor_details_of_polish,natural,needle,pinpoint,reflecting,surface_graining,twinning_wisp"}
      for (const [key, values] of Object.entries(transformedFilters.item_filter.text)) {
        const filterKey = filterReverseMappingSavedSearch[key]; // filterKey = "Key To Symbol"
        newFormat.push({ id: filterKey, value: values.split(",") }); //{ id: "Key To Symbol", value: "bruise", "cavity", "chip", "cloud", "crystal", "etch_channel", "extra_facet", "feather", "grain_center", "indented_natural", "internal_graining", "knot", "laser_drilling", "manufacturing_remnant", "minor_details_of_polish", "natural", "needle", "pinpoint", "reflecting", "surface_graining", "twinning_wisp"}
      }
    }
    
    // item filter from and to
    if (transformedFilters.item_filter.from || transformedFilters.item_filter.to) {
      for (const key of Object.keys(transformedFilters.item_filter.from || {})) {
        const filterKey = filterReverseMappingSavedSearch[key];
        const minValue = transformedFilters.item_filter.from[key];
        const maxValue = transformedFilters.item_filter.to?.[key];
        newFormat.push({ id: filterKey, value: { min: minValue, max: maxValue } });
      }
    }

    // Process from and to market filters
    if (transformedFilters.market_filters) {
      for (const key of Object.keys(transformedFilters.market_filters || {})) {
        if(key === "stock_performance_data.needs_surplus"){
          newFormat.push({ id: key, value: transformedFilters.market_filters[key] });  
        }else{
          const minValue = transformedFilters.market_filters[key].from;
          const maxValue = transformedFilters.market_filters[key].to;
          newFormat.push({ id: key, value: { min: minValue, max: maxValue } });  
        }
      }
    }

    if (transformedFilters.ml_filters) {
      const flattenMlFilters = (node, parentKey = "") => {
        const acc = {};
        if (!node || typeof node !== "object") return acc;

        Object.entries(node).forEach(([childKey, childValue]) => {
          const nextKey = parentKey ? `${parentKey}.${childKey}` : childKey;
          const isContainerObject =
            childValue &&
            typeof childValue === "object" &&
            !Array.isArray(childValue) &&
            childValue.from === undefined &&
            childValue.to === undefined &&
            childValue.min === undefined &&
            childValue.max === undefined;

          if (isContainerObject) {
            Object.assign(acc, flattenMlFilters(childValue, nextKey));
          } else {
            acc[nextKey] = childValue;
          }
        });

        return acc;
      };

      const flatMlFilters = flattenMlFilters(transformedFilters.ml_filters);

      Object.entries(flatMlFilters).forEach(([rawKey, filterValue]) => {
        const key =
          rawKey === "ml_prediction_data.confidence_label"
            ? ML_CONFIDENCE_KEY
            : rawKey;

        if (Array.isArray(filterValue)) {
          if (key === ML_CONFIDENCE_KEY) {
            const availableOptions = MLfilterKeys[ML_CONFIDENCE_KEY] ?? [];
            if (availableOptions.length > 0) {
              const selectedSet = new Set(
                filterValue.map((val) => String(val).toLowerCase())
              );
              const excludedValues = availableOptions.filter(
                (opt) => !selectedSet.has(String(opt).toLowerCase())
              );
              newFormat.push({ id: key, value: excludedValues });
            } else {
              const normalizedValues = filterValue.map((val) =>
                typeof val === "string" ? capitalizeFirstLetter(val) : val
              );
              newFormat.push({ id: key, value: normalizedValues });
            }
          } else {
            const normalizedValues = filterValue.map((val) =>
              typeof val === "string" ? capitalizeFirstLetter(val) : val
            );
            newFormat.push({ id: key, value: normalizedValues });
          }
          return;
        }

        if (filterValue && typeof filterValue === "object") {
          const minValue =
            filterValue.from ?? filterValue.min ?? filterValue.value_from;
          const maxValue =
            filterValue.to ?? filterValue.max ?? filterValue.value_to;

          const hasMin =
                minValue !== undefined && minValue !== null && minValue !== "";
          const hasMax =
                maxValue !== undefined && maxValue !== null && maxValue !== "";

          if (hasMin || hasMax) {
            newFormat.push({
              id: key,
              value: {
                min: hasMin ? Number(minValue) : undefined,
                max: hasMax ? Number(maxValue) : undefined,
              },
            });
          }
          return;
        }

        if (filterValue !== undefined && filterValue !== null) {
          const normalizedValues = [
            typeof filterValue === "string"
              ? capitalizeFirstLetter(filterValue)
              : filterValue,
          ];
          newFormat.push({ id: key, value: normalizedValues });
        }
      });
    }
    return newFormat;
  }
  
  // Helper function to capitalize the first letter of a string
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const [filteredData, { isLoading: loadingFiltered }] =
    useGetFilteredDataMutation();

  const fetchData = async () => {
    if ((filtered.length > 0 || isPreFiltered)) {
      // const page = 0
      try {
        const data = await filteredData({
          args: {
            id: accountDetails.account_id,
            from: 0,
            size: pageSize,
            asc_desc: sortState[0]?.asc_desc ?? "asc",
            sort_by: sortState[0]?.sort_by ?? "sell_offer_cents",
            search: searchParam,
            sort: sortState,
            state: activeTab == 3 ? "repriced" : "",
            is_filter_locked: activeTab == 1 ? false : activeTab == 2 ? true : "",
            isSearched: searchParam !== prevSearch,
          },
          body: isPreFiltered ? preDefinedFilter : convertToJsonObject(filtered, customFiltersRaw),
        }).unwrap();
        dispatch(setUserTable(data?.data.map((item) => mapping(item))));
        dispatch(setPageCount(data?.total_matching_count));
        dispatch(setIsPreFiltered(false));
        setIsPreFilteredLocal(false);
      } catch (err) {
        const backendMessage = (err && (err.data?.message || err.error || err.status)) || "Something went wrong";
        dispatch(setSeverity("error"));
        dispatch(setAlertText(String(backendMessage)));
        dispatch(setToast(true));
        dispatch(setUserTable([]));
        dispatch(setPageCount(0));
      }

    } else {
      dispatch(setUserTable([]));
      dispatch(setPageCount(0));
    }
    // dispatch(setPreDefinedFilter(0));
  };
  if (isPreFiltered){
    // fetchData(); 
    
    if(preDefinedFilter){
      const newFormat = transformFilters(preDefinedFilter);
      setFiltered(newFormat)
      dispatch(setFilteredRedux(newFormat));
    }
    if(preDefinedSort){
      const newFormat = convertSortObjectToArray(preDefinedSort);
      setSortState(newFormat)
      dispatch(setSorting(newFormat))
    }

    dispatch(setIsPreFiltered(false));
    setIsPreFilteredLocal(false);
    
  }


  useEffect(() => {
    (async () => {
      if (filtered.length > 0 && !isNaN(page)) {
        try {
          const data = await filteredData({
            args: {
              id: accountDetails.account_id,
              from: page ? pageSize * page : 0,
              size: pageSize,
              asc_desc: sortState[0]?.asc_desc ?? "asc",
              sort_by: sortState[0]?.sort_by ?? "sell_offer_cents",
              search: searchParam,
              sort: sortState,
              state: activeTab == 3 ? "repriced" : "",
              is_filter_locked: activeTab == 1 ? false : activeTab == 2 ? true : "",
              isSearched: searchParam !== prevSearch,
            },
            body: isPreFiltered ? preDefinedFilter : convertToJsonObject(filtered, customFiltersRaw),

            // filtered = [{"id"=>"shape", "value" => ["princess", ..................]}, {}, {}]
            // convertToJsonObject(filtered) = {"item_filter"=>{"from"=>{}, "to"=>{}, "discrete"=>{"diamond#shape"=>["0000round"]}, "text"=>{}}}
          }).unwrap();
          // console.log({ data });

          dispatch(setUserTable(data?.data.map((item) => mapping(item))));
          dispatch(setPageCount(data?.total_matching_count));
        } catch (err) {
          const backendMessage = (err && (err.data?.message || err.error || err.status)) || "Something went wrong";
          dispatch(setSeverity("error"));
          dispatch(setAlertText(String(backendMessage)));
          dispatch(setToast(true));
          dispatch(setUserTable([]));
          dispatch(setPageCount(0));
        }
      } else {
        dispatch(setUserTable(data?.data.map((item) => mapping(item))));
        dispatch(setPageCount(data?.total_matching_count));
      }
    })();
  }, [filtered, page, pageSize, sortState, searchParam, activeTab]);

  const [selectedItems, setSelectedItems] = useState([]);
  const handleSelectionChange = (selectedRows) => {
    setSelectedItems(selectedRows);
  };

  const handleClick = (event, header, type) => {
    // Check if shift key is pressed
    if (event.shiftKey) {
      // check if the current sort and type is present in array
      // if present remove the sort, if present and type is different then change the type

      setSortState((prev) => {
        let x = [...prev];

        let obj = x.find((item) => item.sort_by === sortMapping[header.id]);

        if (!obj || x.length === 0) {
          let data = {
            sorting: true,
            asc_desc: type,
            sort_by: sortMapping[header.id],
          };

          x.push(data);
        } else {
          if (obj.asc_desc === type) {
            x = x.filter((item) => item.sort_by !== sortMapping[header.id]);
          } else {
            x = x.map((item) => {
              if (item.sort_by === sortMapping[header.id]) {
                // Create a new object with the desired changes
                return {
                  ...item,
                  asc_desc: type,
                };
              }
              return item;
            });
          }
        }

        const buttonClickedEvent = {
          event_type: `v2_pricetable_MultiSort`,
          value: sortState,
        };
        amplitude.track(buttonClickedEvent);

        dispatch(setSorting(x));
        return x;
      });
    } else {
      // Handle regular click
      // console.log("Regular click");
      let data = {
        sorting: true,
        asc_desc: type,
        sort_by: sortMapping[header.id],
      };

      const len = sortState.length;
      if (len > 1) {
        const buttonClickedEvent = {
          event_type: `v2_pricetable_sort`,
          value: [data],
        };
        amplitude.track(buttonClickedEvent);
        setSortState([data]);
        dispatch(setSorting([data]));
      } else {
        if (
          sortState[0] &&
          sortState[0].sort_by == sortMapping[header.id] &&
          sortState[0].asc_desc == type
        ) {
          const buttonClickedEvent = {
            event_type: `v2_pricetable_sort`,
            value: [],
          };
          amplitude.track(buttonClickedEvent);

          setSortState([]);
          dispatch(setSorting([]));
        } else {
          const buttonClickedEvent = {
            event_type: `v2_pricetable_sort`,
            value: [data],
          };
          amplitude.track(buttonClickedEvent);

          setSortState([data]);
          dispatch(setSorting([data]));     
        }
      }
    }
    navigate(`/price_co-pilot?page=0`);
  };
 
  



  useEffect(() => {
    if (prevSearch !== searchParam) {
      setPrevSearch(searchParam);
    }
  }, [userTable]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-full w-full">
        <CircularProgress />
      </div>
    );
  } else if (userTable) {
    return userTable ? (
      <div className="w-full h-[calc(100vh-50px)] flex flex-col ">
        <TopFilterDrawer
          open={openDrawer}
          onClose={(ev) => toggleDrawer(ev)}
          sortState={sortState}
          filtered={filtered}
          setFiltered={(value) => {
            if (absSort) {
              query.set("page", 0);
              navigate(`/price_co-pilot?${query}`);
            } else {
              navigate(`/price_co-pilot?page=0`);
            }
            // Keep Redux in sync so background refreshes preserve filters
            dispatch(setFilteredRedux(value));
            setFiltered(value);
          }}
        />
        <header className="min-h-[50px] w-full flex items-center overflow-x-scroll no-scrollbar justify-between pr-4 bg-white border-l-0 border-t-0 border-b border-solid border-[#EBEBEB] h-[50px] z-[100]">
          <div className="pl-4 flex xl:gap-4 lg:gap-1 items-center w-auto">
            <TabSlider
              tabsList={[
                {key: "All", value: "all", width: "70px", ind: 0, left: 0, icon: <ListChecks width='12'/>},
                {key: "Pending", value: "pending", width: "100px", ind: 1, left: 18, icon: <ListTodo width='12'/>},
                {key: "Locked", value: "locked", width: "100px", ind: 2, left: 45, icon: <Lock width='12'/>},
                {key: "Repriced", value: "repriced", width: "100px", ind: 3, left: 75, icon: <Check width='12'/>},
              ]} // If any changes are made in tabsList, we need to change the index where we using it (look for tabsList in this file).
              activeTab={activeTab}
              setActiveTabCurrent={setActiveTab}
            />
            <SearchBar
              setSearchParam={(value) => {
                setSearchParam(value);
                setPage(0);
                navigate(`/price_co-pilot?page=0`);
              }}
              searchParam={searchParam}
            />
            {/* {Object.keys(criteriaMap).length > 0 ? (
              <>
                <div className="text-sm font-medium text-[#838383] ml-2">Criteria :</div>
                <div className="flex gap-1 ml-1">
                  <CategoryArrayGenerated data={criteriaMap} />
                </div>
              </>
            ) : null} */}
          </div>
          
          <div className="flex justify-center w-auto items-center gap-2">
          
          <>
              <button
              className={cn(
                "self-end rounded-md flex gap-[0.200rem] items-center justify-center px-3 h-8 border-solid border-[1px] border-[#1E90FF] text-[#1E90FF] font-medium text-[0.75rem] w-max",
                filtered.length > 0
                
                  ? "bg-[#A4D9FF] text-[#1E90FF]"
                  : "bg-transparent text-[#1E90FF]"
              )}
              onClick={handleBulkClick}
            >
               Bulk Actions
            </button>
              <Menu
                anchorEl={anchorBulkEl}
                open={open}
                onClose={handleBulkClose}
              >
                <MenuItem disableRipple>
                  <BulkLock
                    selectedItems={selectedItems}
                    filters={filtered}
                    allSelected={allSelected}
                    searchParam={searchParam}
                    activeTab={activeTab}
                  />
                </MenuItem>
                <MenuItem disableRipple>
                  <BulkRepricing
                    selectedItems={selectedItems}
                    allSelected={allSelected}
                    filters={filtered}
                    searchParam={searchParam}
                    activeTab={activeTab}
                    configSort={sort_by}
                    handleBulkClose={handleBulkClose}
                  />
                </MenuItem>
                <MenuItem disableRipple>
                  <BulkAutoReprice
                    selectedItems={selectedItems}
                    allSelected={allSelected}
                    filters={filtered}
                    searchParam={searchParam}
                    activeTab={activeTab}
                    configSort={sort_by}
                    handleBulkClose={handleBulkClose}
                  />
                </MenuItem>
              </Menu>
            </>
          {/* <BulkPricingModal open={true} context={"list"} /> */}
            <DownloadMenu accountDetails={accountDetails} filters={filtered} searchParam={searchParam} activeTab={activeTab} sort={sortState} from={page ? pageSize * page : 0} size={pageSize} />
          
            <button
              className={cn(
                "self-end rounded-md flex gap-[0.200rem] items-center justify-center px-3 h-8 border-solid border-[1px] border-[#1E90FF] text-[#1E90FF] font-medium text-[0.75rem] w-max",
                filtered.length > 0
                
                  ? "bg-[#A4D9FF] text-[#1E90FF]"
                  : "bg-transparent text-[#1E90FF]"
              )}
              onClick={(ev) => {
                ev.stopPropagation();
                toggleDrawer(ev);
              }}
            >
            <FilterIcon className=' h-4 w-4' />  Search My Stock
            </button>
          </div>
        </header>
       
        <div className="h-full w-full overflow-auto">
          <PriceTable
            data={userTable}
            isRepricing={activeTab === 3}
            currentPage={page}
            allSelected={allSelected}
            setAllSelected={setAllSelected}
            setCurrentPage={(ev, page) => {
              if(absSort){
                query.set("page", page);
                navigate(`/price_co-pilot?${query}`);
              }else{
              navigate(`/price_co-pilot?page=${page}`);
              }
            }}
            // handleOnSort={handleOnSort}
            handleOnSort2={handleClick}
            // sorting={sorting}
            isFetching={isFetching}
            currentData={currentData}
            setPageSize={setPageSizeFn}
            pageSize={pageSize}
            sortState={sortState}
            filterLoading={loadingFiltered}
            // sear={setSearchParam}
            onSelectionChange={handleSelectionChange}
          />
        </div>
      </div>
    ) : (
      <div>No items Available.</div>
    );
  } else if (isError) {
    return <div>{error}</div>;
  }
};

export default PriceCoPilot;
